export default __webpack_public_path__ + "media/4421d1dc4711c47734bca76909cd4d5e36d6425316c456b9c16834be10928106.svg";